import { render, staticRenderFns } from "./real-person.vue?vue&type=template&id=0343ad88&scoped=true&"
import script from "./real-person.vue?vue&type=script&lang=ts&"
export * from "./real-person.vue?vue&type=script&lang=ts&"
import style0 from "./real-person.vue?vue&type=style&index=0&id=0343ad88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0343ad88",
  null
  
)

export default component.exports